import OrderHandler from "../OrderHandler";
import ItemRow from "./ItemRow";

export default class CartItems {
	total: number;
	spanTotal: HTMLSpanElement;

	constructor() {
		this.spanTotal = document.querySelector('.bill-total div:nth-child(3) span:last-child');

		this.init();
	}

	private init() {
		this.CreateCartItems();

		const spanTotalText: HTMLDivElement = document.querySelector('.bill-total div:nth-child(3) span');
		if (OrderHandler.hasExpressDelivery) {
			const expressDeliveryText = spanTotalText.dataset.lang.includes("da") ? "ekspres levering" : "express delivery";
			spanTotalText.innerText = `${spanTotalText.dataset.text} + ${expressDeliveryText}`;
		} else {
			spanTotalText.innerText = spanTotalText.dataset.text;
		}
	}

	private CreateCartItems() {
		const orderItems = document.getElementById("order-items");
		orderItems.innerHTML = "";
		this.total = 0;

		OrderHandler.order.items.forEach(item => {
			const itemRow = new ItemRow(item);
			const row = itemRow.createRow();

			if (item.id !== OrderHandler.EXPRESS_DELIVERY_ID) {
				this.total += itemRow.cost * item.count;
			}
			orderItems.append(row);
		});
		this.spanTotal.innerHTML = `${(this.total + OrderHandler.totalExpressDeliveryCost)} Kr.`;
	}
}
